var DS3_EmailVerification = new Object();

DS3_EmailVerification.version = '1.0.0';
DS3_EmailVerification.$form = null;
DS3_EmailVerification.init = function ($form)
{

  this.$form = $form;

  const $emailField = $form.find('input[name="email"]');
  if (helpers.shouldDebug('ds3')) console.log('[DS3.EmailVerification] init', $emailField);

  const showEmailError = () =>
  {
    $emailField.addClass("invalid error");
    const $errorBlock = $emailField.closest(".input").next(".hs-error-msgs");

    const errorHTML = `
      <ul class="no-list hs-error-msgs inputs-list custom-error" role="alert">
        <li>
          <label class="hs-error-msg hs-main-font-element">
            Please enter a different email address.
          </label>
        </li>
      </ul>
    `;

    if ($errorBlock.length <= 0)
    {
      $emailField.closest(".input").after(errorHTML);
    } else
    {
      $errorBlock.html(errorHTML);
    }
  };

  const clearEmailError = () =>
  {
    $emailField.removeClass("invalid error");
    $emailField.closest(".input").next(".custom-error").remove();
  };

  const isEmailBlocked = (email) =>
  {
    var _parent = DS3;
    var $parentEl = _parent.$el;

    const emailBlocklist = $parentEl.data('blocklist').trim() === '' ? false : $parentEl.data('blocklist').trim().split(',');
    if (!emailBlocklist) return;

    const blockedEmailEntered = sessionStorage.getItem("blocked_email_entered");
    const isBlockedUser = emailBlocklist.includes(email) || blockedEmailEntered !== null;

    if (isBlockedUser)
    {
      sessionStorage.setItem("blocked_email_entered", email);

      if (helpers.shouldDebug('ds3')) console.info('[DS3.EmailVerification] blocked email entered');
      showEmailError();

      return isBlockedUser;
    }
  };

  $emailField.on("blur input focus", () =>
  {
    if (isEmailBlocked($emailField.val()))
    {
      if (helpers.shouldDebug('ds3')) console.log('[DS3.EmailVerification] isEmailBlocked called');
      showEmailError();
    } else
    {
      clearEmailError();
    }
  });
};

export default DS3_EmailVerification;